import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { prepareSnapshot } from "@/lib/snapshot";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Fertig gebaute Seite vom Server (deploy/prerender_heads.js) bleibt sichtbar, bis die App im Hintergrund
// vollständig aufgebaut ist (lib/snapshot.js). Ohne Snapshot: wie bisher.
prepareSnapshot();

const root = ReactDOM.createRoot(document.getElementById("root"));
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
// Während die fertige Seite sichtbar ist, baut React in kleinen Häppchen auf (Transition = unterbrechbar),
// damit der Browser nicht lange blockiert (Lighthouse „Total Blocking Time“).
if (window.__SNAP_ACTIVE) React.startTransition(() => root.render(app));
else root.render(app);
